
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.78 9.262a1.645 1.645 0 011.107-.435c.91 0 1.65.74 1.65 1.649 0 .91-.74 1.65-1.65 1.65-.909 0-1.649-.74-1.649-1.65 0-.124.017-.249.046-.367l-4.022-2.35A1.692 1.692 0 01.416 6.522a1.692 1.692 0 012.846-1.236l3.982-2.321c-.028-.13-.05-.26-.05-.396 0-.937.756-1.694 1.693-1.694.938 0 1.695.757 1.695 1.694a1.692 1.692 0 01-2.847 1.237L3.754 6.127c.028.13.05.26.05.396 0 .135-.022.265-.05.395L7.78 9.262zm1.671-6.693a.566.566 0 00-.565-.565.566.566 0 00-.564.565c0 .31.254.565.564.565.311 0 .565-.254.565-.565zm-7.34 4.519a.566.566 0 01-.565-.565c0-.31.254-.565.564-.565.311 0 .565.254.565.565 0 .31-.254.565-.565.565zm6.21 3.4c0 .31.255.564.565.564.311 0 .565-.254.565-.565a.566.566 0 00-.565-.564.566.566 0 00-.564.564z","fill":"#fff"}})])
          )
        }
      }
    